import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  pushUserFavoritesData,
  setListView,
  setTriggerRegister,
  setUserFavoritesData,
} from "../store/reducers/listingReducer";
import { config } from "../config";
import { useLocation, useNavigate } from "react-router-dom";
import { addToFavorites, removeFromFavorites } from "../services/api";
import { ListItem, ListItemCommercial } from "./ListItem";

interface IProps {
  currentListings: any;
}

export const ListView = (props: IProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const isCommercial = location.pathname.startsWith("/commercial");

  const [loading, setLoading] = React.useState<boolean>(false);
  const [filteredListings, setFilteredListings] = React.useState<any>([]);
  const [currentPage, setCurrentPage] = React.useState<number>(1);
  const itemsPerPage = 10; // Change this to the desired number of items per page

  const logged = useSelector((state: any) => state.listingReducer.logged);
  const userListView = useSelector(
    (state: any) => state.listingReducer.userListView
  );
  const filterValues = useSelector(
    (state: any) => state.listingReducer.filterValues
  );
  const listings = useSelector((state: any) => state.listingReducer.listings);
  const userFavorites = useSelector(
    (state: any) => state.listingReducer.userFavorites
  );

  const appType = useSelector((state: any) => state.listingReducer.appType);

  React.useEffect(() => {
    setLoading(true);
    setFilteredListings(filterListing());
    setTimeout(() => {
      setLoading(false);
    }, 600);
  }, [filterValues, listings, currentPage]);

  function filterListing() {
    let returnListings = listings;
    /*if (filterValues.filterState && filterValues.filterState !== '') {
                returnListings = listings.filter((item: any) => item.state === filterValues.filterState);
            }*/
    if (filterValues.filterTime && filterValues.filterTime !== "") {
      let timeCheck =
        Math.floor(Date.now() / 1000) - filterValues.filterTime * 24 * 60 * 60;
      returnListings = returnListings.filter(
        (item: any) => item.time_listed >= timeCheck
      );
    }
    /*if (filterValues.filterLeadOwner && filterValues.filterLeadOwner !== '') {
                returnListings = returnListings.filter((item: any) => item.lead_owner?.toLowerCase() === filterValues.filterLeadOwner.toLowerCase());
            }*/
    if (filterValues.filterLeadStatus && filterValues.filterLeadStatus !== "") {
      returnListings = returnListings.filter(
        (item: any) =>
          item.lead_status_options_public_id === filterValues.filterLeadStatus
      );
    }
    if (filterValues.filterBounds && filterValues.filterBounds !== "") {
      returnListings = returnListings.filter(
        (item: { latitude: string; longitude: string }) => {
          const lat = parseFloat(item.latitude);
          const lng = parseFloat(item.longitude);
          return filterValues.filterBounds.contains(
            new window.google.maps.LatLng(lat, lng)
          );
        }
      );
      //console.log('owner-', returnListings)
    }
    return returnListings;
  }

  function handleListView() {
    dispatch(setListView(false));
  }

  function handleView(listingUniqueId: string) {
    if (!logged) {
      return;
    }
    navigate(config.path + "listing/" + listingUniqueId);
    //dispatch(setListView(false));
  }

  function handleRegister() {
    dispatch(setTriggerRegister(true));
    return;
  }

  const totalPages = Math.ceil(filteredListings.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentListings = filteredListings.slice(startIndex, endIndex);

  async function doActionFavorites(listingFav: any) {
    if (!logged) {
      return;
    }
    let params: any = {};
    params["listing_unique_id"] = listingFav.listing_unique_id;
    if (isFavorited(listingFav)) {
      let result = await removeFromFavorites(params);
      if (!result?.data.success) {
        return;
      }
      let newFavorites =
        removeFavoritesItemByListingListingUniqueId(listingFav);
      dispatch(setUserFavoritesData(newFavorites));
    } else {
      let result = await addToFavorites(params);
      if (!result?.data.success) {
        return;
      }
      if (result) {
        dispatch(pushUserFavoritesData(result?.data.data));
      }
    }
  }

  function removeFavoritesItemByListingListingUniqueId(listingFav: any) {
    // Use Array.prototype.filter to create a new array without the target item
    return userFavorites.filter(
      (item: any) => item.listing_unique_id !== listingFav.listing_unique_id
    );
  }

  function isFavorited(listingFav: any) {
    for (let i = 0; i < userFavorites.length; i++) {
      if (userFavorites[i].listing_unique_id === listingFav.listing_unique_id) {
        return true; // Found the target listing_unique_id in the array
      }
    }
    return false;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {props.currentListings.map((listing: any) =>
        appType === "commercial" ? (
          <ListItemCommercial
            key={listing.listing_unique_id}
            listing={listing}
          />
        ) : (
          <ListItem key={listing.listing_unique_id} listing={listing} />
        )
      )}
    </div>
  );
};
export default ListView;
